/**
 * Authentication event type
 */
export enum AuthEventType {
  /**
   * User has successfully signed in
   */
  SignIn,

  /**
   * Unsuccessful sign-in attempt
   */
  InvalidSignIn,

  /**
   * User has signed out
   */
  SignOut
}


export interface IAuthEvent {
  type: AuthEventType;
}
